import { useApiGet, useApiPost, useApiPostQuery } from 'mf_core/query';
import { useMutation } from '@tanstack/react-query';

export function useGetInsights() {
  const apiGet = useApiGet();

  return useMutation({
    mutationFn: () => {
      return apiGet(
        '/exp-looker_dummy_link/v1/insights/Insight_HomePageWidget?authorizedproducts=true'
      );
    },
  });
}

export function useInsightQuery(reqBody: any) {
  let response: any = [];
  const currentInsightBodyParam = reqBody;
  response = useApiPostQuery(
    `/exp-looker/v1/run-inline-query-v2`,
    currentInsightBodyParam
  );
  return response;
}

export function useInsightQueryMutation() {
  const apiPost = useApiPost();

  return useMutation({
    mutationFn: (reqBody?: any) => {
      const data = apiPost(`/exp-looker/v1/run-inline-query-v2`, reqBody);
      return data;
    },
    onError: (error) => {
      console.error(error);
    },
  });
}

export type PlacementData = {
  category: string;
  id: string;
  product: string;
  sales: string;
  sku: string;
  vendor: string;
};

export type InsightResponseTO = {
  placementId: string;
  response: any[];
};

export const PLACEMENT_IDS = {
  TopCategoryGrowth: 'Insight_TopCategoryGrowthWithTopProductSales',
  TopProductGrowth: 'Insight_TopProductGrowthOnTopCategory',
  TopVendorGrowth: 'Insight_TopVendorGrowthWithTopProductSales',
};
